import { decodeBase64Image } from '../utils'
import { Col, Flex } from './flex'
import { Modal } from './modal'
import { PrimaryText, Text } from './text'

interface Props {
    onClose: () => void
    title?: string
    time?: string
    image?: string
}

export const PodModal = ({ onClose, title, time, image }: Props) => (
    <Modal onClose={onClose}>
        <div>
            <Flex className="pr-8 pb-4 flex-col sm:flex-row">
                <Text className="pr-4">{title}</Text>
                <PrimaryText>{time}</PrimaryText>
            </Flex>
            <Col className="max-w-2xl max-h-96 md:min-w-md md:min-h-64 justify-center items-center">
                <img src={decodeBase64Image(image)} alt="POD" />
            </Col>
        </div>
    </Modal>
)
